import { ReportingControllerBaseConfig } from '../../../base';
import { DatabaseFilterController } from './databaseFilterInterface';
import { DatabaseFilterViewProps } from './databaseFilterProps';

export function createDatabaseFilterController(
    config: ReportingControllerBaseConfig
): DatabaseFilterController {
    return {
        useProps(context, item, props): DatabaseFilterViewProps {
            return {
                popover: {
                    isOpen: props.disclosure.isOpen,
                    onClose: props.disclosure.onClose,
                    onOpen: props.disclosure.onOpen,
                },
                property: {
                    label: item.property.display_name,
                },
                value: {
                    label: props.value?.toString() ?? 'N/A',
                },
            };
        },
    };
}
